import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { TriageSidebar } from "../Layouts/TriageSidebar";

export class PhysicalExaminationInspection extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      FundalHeight: "",
      PalpationLeopoldManeuver: "",
      FetalHeartRate: "",
      FAM: "",
      VulvaStatus: "",
      AmnioticFluid: "",
      FGM: "",
      PerineumStatus: "",
      VaginaStatus: "",
      CervixStatus: "",
      loading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
   this.setState({
    loading: true
   })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/physicalexam/inspection",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
         })
        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            window.location.href = "/physical/examination/pelvic";
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const {
      FundalHeight,
      PalpationLeopoldManeuver,
      FetalHeartRate,
      FAM,
      VulvaStatus,
      AmnioticFluid,
      FGM,
      PerineumStatus,
      VaginaStatus,
      CervixStatus,
      loading
    } = this.state;

    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Inspection:{" "}
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Fundal Height
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={FundalHeight}
                      name="FundalHeight"
                      type="number"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Palpation Leopold Maneuver
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={PalpationLeopoldManeuver}
                      name="PalpationLeopoldManeuver"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      FAM
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={FAM}
                      name="FAM"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Fetal Heart Rate
                    </h6>
                    <select className="form-control" required>
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option className="yesSelected" value="yes">
                          Yes
                        </option>
                        <option className="noSelected" value="no">
                          No
                        </option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1 hiddenPart" style={displayHidden}>
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Fetal Heart Rate
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={FetalHeartRate}
                      name="FetalHeartRate"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Status the Vulva
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={VulvaStatus}
                      name="VulvaStatus"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="normal">Normal</option>
                        <option value="pathologic">Pathologic</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      FGM
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={FGM}
                      name="FGM"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Amniotic Fluid
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AmnioticFluid}
                      name="AmnioticFluid"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Status of the perineum
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={PerineumStatus}
                      name="PerineumStatus"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="normal">Normal</option>
                        <option value="pathologic">Pathologic</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Status of the Vagina
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={VaginaStatus}
                      name="VaginaStatus"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="normal">Normal</option>
                        <option value="pathologic">Pathologic</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Status of the Cervix
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={CervixStatus}
                      name="CervixStatus"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="normal">Normal</option>
                        <option value="pathologic">Pathologic</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Physical .Examination Inspection Saved
                Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default PhysicalExaminationInspection;
